import ContentPageLayout from '../../components/common/ContentPageLayout';
import { useAboutUs } from '../../hooks/useAboutUs';

function AboutUsPage() {
  const { aboutUs, loading, error } = useAboutUs();

  return (
    <ContentPageLayout
      title={aboutUs?.title || 'About Us'}
      content={aboutUs?.content}
      loading={loading}
      error={error}
    />
  );
}

export default AboutUsPage;
